import { useTranslation } from 'react-i18next';
import {
  Headings,
  ModalOverlay,
  SentaraLogo,
  VirtualIcon
} from '@sentara-health/optimahealth_web';
import { VirtualVisitModalBox } from 'templates';
import { navigateToExternalUrl, SuperScript } from 'common';
import { useContext } from 'react';
import { GlobalContext } from 'context';

interface LabServicePopUpProps {
  closeModal: () => void;
}
function LabServicePopUp({
  closeModal,
}: Readonly<LabServicePopUpProps>) {
  // Initialize translation hook
  const { t } = useTranslation();
  const { ssoEndPoints } = useContext(GlobalContext);

  const sentaraDisclaimerList = [
    { superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_ONE}</sup>, text: t('virtualVisitCare.LabServices.sentaraContent.disclaimerNote1'), style: 'mt-3' },
    { superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_TWO}</sup>, text: t('virtualVisitCare.disclaimerNote1Common'), style: 'mt-2' },
    { superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_THREE}</sup>, text: t('virtualVisitCare.LabServices.sentaraContent.disclaimerNote3'), style: 'mt-2' },
  ]


  return (
    <ModalOverlay
      className="virtual-visit-box"
      data-testid={'virtualVisitSelectionId'}
      isOpen
      onClose={closeModal}
      overlayInfo="virtual visit selection"
    >
      <Headings
        level={2}
        text={t('virtualVisitCare.selectProvider')}
        variant="regular"
      />
      <div className="curved-box-single-box gap-4 mt-3 w-100">
        <VirtualVisitModalBox
          logoImage={<SentaraLogo />}
          title={t(
            'virtualVisitCare.LabServices.sentaraContent.title'
          )}
          costInfo={t('virtualVisitCare.LabServices.sentaraContent.costInfo')}
          badgeImage={<VirtualIcon />}
          content={t(
            'virtualVisitCare.LabServices.sentaraContent.labServiceContent'
          )}
          superTextOne={SuperScript.VIRTUAL_DISCLAIMER_ONE}
          superTextTwo={SuperScript.VIRTUAL_DISCLAIMER_TWO}
          superTextThree={SuperScript.VIRTUAL_DISCLAIMER_THREE}
          costValue={SuperScript.VIRTUAL_DISCLAIMER_ONE}
          buttonLabel={t(
            'virtualVisitCare.scheduleAppointment'
          )}
          buttonTestId='scheduleSentarappointment'
          buttonOnClick={() => {
            navigateToExternalUrl(ssoEndPoints?.LAB_SERVICES_URL); // Navigate to the URL
          }}
          minHeight={'200'}
          disclaimers={sentaraDisclaimerList}
        />
      </div>
    </ModalOverlay>
  );
}

export default LabServicePopUp;